<script lang="ts" setup>
import { Filter as filterate } from '@element-plus/icons-vue' // 引入 Edit 图标 Filter是数组方法名需要改一下名字在引入，否则不生效
import type { AnyColumn } from 'element-plus/es/components/table-v2/src/common'
import type { Dictionary } from '@/types/global'
import { isNullOrUndefined } from '@/utils'
// import ColumnStatus from 'components/column-status/index.vue'
// interface Row {
//   deviceName: string,
//   deviceNumber: string,
//   energyTypeName: string,
//   templateDeviceName: string,
// }
const props = withDefaults(defineProps<{
  pageNum: number,
  pageSize: number,
  isSelected?: boolean, // 是否包含多选框
  count: number, // 总条数
  tableData: Dictionary[],
  columns: Dictionary[],
  hiddenPagination?: boolean,
  getRowKeys?: any,
  handleSelectionChange?: any,
  handleSelectAllChange?: any,
  tableref?: any,
  selectable?: any,
  autoHeight?: Dictionary,
  sortPropsHead?: string, // 默认按照那个头部字段排序
  show_overflow_tooltip?: boolean,
  autoScroll?: boolean,
  hiddenIndex?: boolean,
  border?: boolean,
  defaultExpandAll?: boolean,
}>(), {
  count: 0,
  isSelected: false,
  pageNum: 1,
  pageSize: 20,
  hiddenPagination: false,
  show_overflow_tooltip: false, // table中每一格的内容是否隐藏，然后悬浮显示全部内容
  autoScroll: false,
  hiddenIndex: false,
  border: false,
  defaultExpandAll: false,
})
const emit = defineEmits(['sizeChange', 'currentChange', 'pageDropdown', 'pageSort', 'cellClick', 'mouseEnter', 'rowClick', 'sortChange'])

const renderComponent = (props: Dictionary) => {
  return props.render(props.row)
}
function handleSizeChange(newPageSize: number) {
  emit('sizeChange', newPageSize)
}
function handleCurrentChange(newPageNum: number) {
  emit('currentChange', newPageNum)
}

// 单元格点击事件
function handleCellClickCell(row: any, column: AnyColumn) {
  // console.log(row, column, cell, event)
  emit('cellClick', row, column)
}

// 单元格鼠标移入事件
function handleCellMouseEnter(row: any, column: any, cell: any) {
  emit('mouseEnter', column, cell)
}

// TABLE_COLUMNS 定义示例
// const TABLE_COLUMNS = [{
//   prop: 'deviceName',
//   label: '设备名称',
//   width: '170',
//   render: (row: Row) => {
//     return (
//         <div>{row.deviceName}</div>
//     )
//   },
// }, {
//   prop: 'deviceNumber',
//   label: '设备编号',
//   render: (row: Row) => {
//     return (
//         <div>{row.deviceNumber}</div>
//     )
//   },
// }, {
//   prop: 'energyTypeName',
//   label: '能源类型',
//   formatter(row: Row) {
//     if (row.energyTypeName === '111')
//       return '我是1111'
//     return 'asfasfasf'
//   },
// }, {
//   prop: 'templateDeviceName',
//   label: '设备类型',
//   render: (row: Row) => {
//     let backgroundColor = ''
//     let text = ''
//     if (row.templateDeviceName === '供') {
//       backgroundColor = '#4b88ff'
//       text = '我是供'
//     } else {
//       backgroundColor = '#e6ad00'
//       text = '我是供暖'
//     }
//     return ( // 可以内嵌组件进行渲染
//         <ColumnStatus backgroundColor={backgroundColor} text={text}></ColumnStatus>
//     )
//   },
// }, {
//   label: '操作',
//   render: (row: Row) => {
//     return ( // 可以内嵌组件进行渲染
//       <>
//         <el-button link type="primary" onClick={() => router.push(`/product/detail/${row.deviceNumber}`)}>查看</el-button>
//         <el-button link type="primary" onClick={deleteClick}>设备管理</el-button>
//         <el-button link type="primary" onClick={deleteClick}>删除</el-button>
//       </>
//     )
//   },
// }]

// 给el-table绑定ref，导出后给父组件使用
const tableref = ref<any>(null)
defineExpose({
  tableref,
})

// 过滤
function handleDropdown(DropdownItem: any) {
  // console.log(DropdownItem)
  emit('pageDropdown', DropdownItem)
}

// const sortStatus = ref(true)
// 排序
// function handleSort(Sort:any, val:any) {
//   sortStatus.value = !sortStatus.value
//   console.log(Sort, val) // true是正序，false是倒序
//   emit('pageSort', Sort, val)
// }

// el-table排序的属性sortable 有个方法 :sort-method="sortMethod"
function sortMethodProduct(row1: any, row2: any) {
  // console.log('sortMethod', row1, row2, row1.createTime)
  console.log('sortProduct')
  if (row1.createTime > row2.createTime)
    return 1
  else
    return -1
}

// el-table排序的属性sortable 有个方法 :sort-method="sortMethod"
function sortMethodDevice(row1: any, row2: any) {
  // console.log('sortMethod', row1, row2, row1.latestOnlineTime)
  console.log('sortDevice')
  if (row1.lastCommunicationTime > row2.lastCommunicationTime)
    return 1
  else
    return -1
}

// function filterHandler(value:any, row:any, column:any) {
//   // console.log(value, row, column)
//   const property = column.property
//   return row[property] === value
// }

function handleRowClick(row: any) {
  emit('rowClick', row)
}
let timer: undefined | number
const clearScroll = () => {
  if (!props.autoScroll) return
  clearInterval(timer)
  timer = undefined
}
const createScroll = () => {
  if (!props.autoScroll) return
  clearScroll()
  // 拿到 table
  const table = tableref.value.layout.table.refs
  // 拿到可以滚动的元素
  const tableWrapper = table.bodyWrapper.firstElementChild.firstElementChild
  timer = window.setInterval(() => {
    tableWrapper.scrollTop += 1.5
    // 判断是否滚动到底部，如果到底部了置为0（可视高度+距离顶部=整个高度）
    if (tableWrapper.clientHeight + tableWrapper.scrollTop >= (tableWrapper.scrollHeight - 5))
      tableWrapper.scrollTop = 0
  }, 100)
}

function handleSortChange(data: any) {
  emit('sortChange', data)
}

onMounted(() => {
  props.autoScroll && createScroll()
})
onUnmounted(() => {
  props.autoScroll && clearScroll()
})

</script>

<template>
  <div v-autoHeight="props.autoHeight" class="jy-table">
    <el-table ref="tableref" :border="border" :data="tableData" header-cell-class-name="header-cell"
      cell-class-name="row-cell" :row-key="getRowKeys" default-expand-all
      :default-sort="{ prop: sortPropsHead, order: 'descending' }" @cell-click="handleCellClickCell"
      @cell-mouse-enter="handleCellMouseEnter" @select="handleSelectionChange" @select-all="handleSelectAllChange"
      @row-click="handleRowClick" @mouseover.native="clearScroll" @mouseleave.native="createScroll"
      @sort-change="handleSortChange">
      <el-table-column v-if="isSelected" type="selection" :reserve-selection="true" :selectable="selectable" />
      <el-table-column v-if="!hiddenIndex" type="index" label="序号" width="60" />
      <template v-for="(item, index) in columns" :key="index">
        <el-table-column v-if="item.render" v-bind="item"
          :show-overflow-tooltip="show_overflow_tooltip && item.label !== '操作'"
          :class-name="item.label === '操作' ? 'table-operation-column' : ''">
          <template #default="scope">
            <render-component :row="scope.row" :render="item.render" />
          </template>
        </el-table-column>
        <!-- 产品&设备列表-筛选 -->
        <el-table-column v-else-if="item.dropdown" v-bind="item" :show-overflow-tooltip="show_overflow_tooltip">
          <template #header>
            {{ item.label }}
            <el-dropdown trigger="click">
              <div style="margin-top: 2px;">
                <el-icon style="margin-top: 2px;margin-left: 10px;cursor: pointer;">
                  <filterate />
                </el-icon>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-for="(item1) in item.dropdown" :key="item1.value" @click="handleDropdown(item1)">
                    {{ item1.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
          <template v-if="!item.formatter" #default="scope">
            {{ isNullOrUndefined(scope.row[item.prop]) || scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}
          </template>
        </el-table-column>
        <!-- 产品-时间排序 -->
        <el-table-column v-else-if="item.sortProduct" v-bind="item" :show-overflow-tooltip="show_overflow_tooltip"
          sortable :sort-method="sortMethodProduct">
          <!-- todo:有sortable这个属性会方便一些，但是不利于扩展，看情况是否留用以下思路 -->
          <!-- <template #header>
            <div class="sort-button">
              {{ item.label }}
              <el-button v-if="!sortStatus" style="color: #777a80;" link @click="handleSort(item.prop, 'SortDown')">
                <el-icon class="sort-icon" style="margin-left: 10px;">
                  <sort-down />
                </el-icon>
              </el-button>
              <el-button v-if="sortStatus" style="color: #777a80;" link @click="handleSort(item.prop, 'SortUp')">
                <el-icon class="sort-icon" style="margin-bottom: 2px;margin-left: 10px;">
                  <sort-up />
                </el-icon>
              </el-button>
            </div>
          </template> -->
          <template v-if="!item.formatter" #default="scope">
            {{ isNullOrUndefined(scope.row[item.prop]) || scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}
          </template>
        </el-table-column>
        <!-- 设备列表-时间排序 -->
        <el-table-column v-else-if="item.sortDevice" v-bind="item" :show-overflow-tooltip="show_overflow_tooltip"
          sortable :sort-method="sortMethodDevice">
          <template v-if="!item.formatter" #default="scope">
            {{ isNullOrUndefined(scope.row[item.prop]) || scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}
          </template>
        </el-table-column>
        <el-table-column v-else v-bind="item" :show-overflow-tooltip="show_overflow_tooltip && item.label !== '操作'"
          :sortable="!!item.sortable">
          <template v-if="!item.formatter" #default="scope">
            {{ isNullOrUndefined(scope.row[item.prop]) || scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}
          </template>
        </el-table-column>
      </template>
      <template #empty>
        <slot v-if="$slots.empty" name="empty" />
      </template>
    </el-table>
    <el-pagination v-if="!hiddenPagination" :current-page="pageNum" :page-size="pageSize" :page-sizes="[5, 20, 50, 100]"
      layout="total, sizes, prev, pager, next, jumper" :total="count" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
  </div>
</template>

<style lang="scss">
// 清除按钮被点击后，保存的focus状态
.sort-button {

  // link button点击后颜色透明
  .el-button.is-plain,
  .el-button.is-text,
  .el-button.is-link {
    color: #777a80;
  }
}

.table-operation-column {
  .cell {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    column-gap: 12px;

    .el-button+.el-button {
      margin-left: 0;
    }
  }

  .el-button+.el-button {
    margin: 0;
  }
}
</style>
